export interface AuraKpi {
    name: string;
    value: number | string;
    unit?: string;
    trend?: 'up' | 'down' | 'stable';
    trendValue?: string;
}
